import * as Yup from 'yup'

export default (value: number) =>
  Yup.object().shape({
    targetPrice: Yup.number()
      .min(value, `Le prix d'objectif ne peut pas être plus petit que ${value}`)
      .required(),
  })
